// Definición del tipo para asegurar la estructura
export type CountryData = {
  [key: string]: {
    description: string; // Nombre del país en inglés
    flag: string; // URL de la miniatura de la bandera (24x18px, SVG)
    dialCode?: string; // Código de marcación telefónica (opcional)
  };
};

// Objeto completo con todos los códigos ISO 3166-1 Alfa-2
export const ISO_COUNTRIES: CountryData = {
  // A
  AF: { description: 'Afghanistan', flag: 'https://flagcdn.com/24x18/af.png', dialCode: '+93' },
  AX: { description: 'Aland Islands', flag: 'https://flagcdn.com/24x18/ax.png', dialCode: '+358' },
  AL: { description: 'Albania', flag: 'https://flagcdn.com/24x18/al.png', dialCode: '+355' },
  DZ: { description: 'Algeria', flag: 'https://flagcdn.com/24x18/dz.png', dialCode: '+213' },
  AS: { description: 'American Samoa', flag: 'https://flagcdn.com/24x18/as.png', dialCode: '+1' },
  AD: { description: 'Andorra', flag: 'https://flagcdn.com/24x18/ad.png', dialCode: '+376' },
  AO: { description: 'Angola', flag: 'https://flagcdn.com/24x18/ao.png', dialCode: '+244' },
  AI: { description: 'Anguilla', flag: 'https://flagcdn.com/24x18/ai.png', dialCode: '+1' },
  AQ: { description: 'Antarctica', flag: 'https://flagcdn.com/24x18/aq.png' },
  AG: { description: 'Antigua and Barbuda', flag: 'https://flagcdn.com/24x18/ag.png', dialCode: '+1' },
  AR: { description: 'Argentina', flag: 'https://flagcdn.com/24x18/ar.png', dialCode: '+54' },
  AM: { description: 'Armenia', flag: 'https://flagcdn.com/24x18/am.png', dialCode: '+374' },
  AW: { description: 'Aruba', flag: 'https://flagcdn.com/24x18/aw.png', dialCode: '+297' },
  AU: { description: 'Australia', flag: 'https://flagcdn.com/24x18/au.png', dialCode: '+61' },
  AT: { description: 'Austria', flag: 'https://flagcdn.com/24x18/at.png', dialCode: '+43' },
  AZ: { description: 'Azerbaijan', flag: 'https://flagcdn.com/24x18/az.png', dialCode: '+994' },

  // B
  BS: { description: 'Bahamas (the)', flag: 'https://flagcdn.com/24x18/bs.png', dialCode: '+1' },
  BH: { description: 'Bahrain', flag: 'https://flagcdn.com/24x18/bh.png', dialCode: '+973' },
  BD: { description: 'Bangladesh', flag: 'https://flagcdn.com/24x18/bd.png', dialCode: '+880' },
  BB: { description: 'Barbados', flag: 'https://flagcdn.com/24x18/bb.png', dialCode: '+1' },
  BY: { description: 'Belarus', flag: 'https://flagcdn.com/24x18/by.png', dialCode: '+375' },
  BE: { description: 'Belgium', flag: 'https://flagcdn.com/24x18/be.png', dialCode: '+32' },
  BZ: { description: 'Belize', flag: 'https://flagcdn.com/24x18/bz.png', dialCode: '+501' },
  BJ: { description: 'Benin', flag: 'https://flagcdn.com/24x18/bj.png', dialCode: '+229' },
  BM: { description: 'Bermuda', flag: 'https://flagcdn.com/24x18/bm.png', dialCode: '+1' },
  BT: { description: 'Bhutan', flag: 'https://flagcdn.com/24x18/bt.png', dialCode: '+975' },
  BO: { description: 'Bolivia (Plurinational State of)', flag: 'https://flagcdn.com/24x18/bo.png', dialCode: '+591' },
  BQ: { description: 'Bonaire, Sint Eustatius and Saba', flag: 'https://flagcdn.com/24x18/bq.png', dialCode: '+599' },
  BA: { description: 'Bosnia and Herzegovina', flag: 'https://flagcdn.com/24x18/ba.png', dialCode: '+387' },
  BW: { description: 'Botswana', flag: 'https://flagcdn.com/24x18/bw.png', dialCode: '+267' },
  BV: { description: 'Bouvet Island', flag: 'https://flagcdn.com/24x18/bv.png', dialCode: '+47' },
  BR: { description: 'Brazil', flag: 'https://flagcdn.com/24x18/br.png', dialCode: '+55' },
  IO: { description: 'British Indian Ocean Territory (the)', flag: 'https://flagcdn.com/24x18/io.png', dialCode: '+246' },
  BN: { description: 'Brunei Darussalam', flag: 'https://flagcdn.com/24x18/bn.png', dialCode: '+673' },
  BG: { description: 'Bulgaria', flag: 'https://flagcdn.com/24x18/bg.png', dialCode: '+359' },
  BF: { description: 'Burkina Faso', flag: 'https://flagcdn.com/24x18/bf.png', dialCode: '+226' },
  BI: { description: 'Burundi', flag: 'https://flagcdn.com/24x18/bi.png', dialCode: '+257' },

  // C
  CV: { description: 'Cabo Verde', flag: 'https://flagcdn.com/24x18/cv.png', dialCode: '+238' },
  KH: { description: 'Cambodia', flag: 'https://flagcdn.com/24x18/kh.png', dialCode: '+855' },
  CM: { description: 'Cameroon', flag: 'https://flagcdn.com/24x18/cm.png', dialCode: '+237' },
  CA: { description: 'Canada', flag: 'https://flagcdn.com/24x18/ca.png', dialCode: '+1' },
  KY: { description: 'Cayman Islands (the)', flag: 'https://flagcdn.com/24x18/ky.png', dialCode: '+1' },
  CF: { description: 'Central African Republic (the)', flag: 'https://flagcdn.com/24x18/cf.png', dialCode: '+236' },
  TD: { description: 'Chad', flag: 'https://flagcdn.com/24x18/td.png', dialCode: '+235' },
  CL: { description: 'Chile', flag: 'https://flagcdn.com/24x18/cl.png', dialCode: '+56' },
  CN: { description: 'China', flag: 'https://flagcdn.com/24x18/cn.png', dialCode: '+86' },
  CX: { description: 'Christmas Island', flag: 'https://flagcdn.com/24x18/cx.png', dialCode: '+61' },
  CC: { description: 'Cocos (Keeling) Islands (the)', flag: 'https://flagcdn.com/24x18/cc.png', dialCode: '+61' },
  CO: { description: 'Colombia', flag: 'https://flagcdn.com/24x18/co.png', dialCode: '+57' },
  KM: { description: 'Comoros (the)', flag: 'https://flagcdn.com/24x18/km.png', dialCode: '+269' },
  CD: { description: 'Congo (the Democratic Republic of the)', flag: 'https://flagcdn.com/24x18/cd.png', dialCode: '+243' },
  CG: { description: 'Congo (the)', flag: 'https://flagcdn.com/24x18/cg.png', dialCode: '+242' },
  CK: { description: 'Cook Islands (the)', flag: 'https://flagcdn.com/24x18/ck.png', dialCode: '+682' },
  CR: { description: 'Costa Rica', flag: 'https://flagcdn.com/24x18/cr.png', dialCode: '+506' },
  CI: { description: "Côte d'Ivoire", flag: 'https://flagcdn.com/24x18/ci.png', dialCode: '+225' },
  HR: { description: 'Croatia', flag: 'https://flagcdn.com/24x18/hr.png', dialCode: '+385' },
  CU: { description: 'Cuba', flag: 'https://flagcdn.com/24x18/cu.png', dialCode: '+53' },
  CW: { description: 'Curaçao', flag: 'https://flagcdn.com/24x18/cw.png', dialCode: '+599' },
  CY: { description: 'Cyprus', flag: 'https://flagcdn.com/24x18/cy.png', dialCode: '+357' },
  CZ: { description: 'Czechia', flag: 'https://flagcdn.com/24x18/cz.png', dialCode: '+420' },

  // D
  DK: { description: 'Denmark', flag: 'https://flagcdn.com/24x18/dk.png', dialCode: '+45' },
  DJ: { description: 'Djibouti', flag: 'https://flagcdn.com/24x18/dj.png', dialCode: '+253' },
  DM: { description: 'Dominica', flag: 'https://flagcdn.com/24x18/dm.png', dialCode: '+1' },
  DO: { description: 'Dominican Republic (the)', flag: 'https://flagcdn.com/24x18/do.png', dialCode: '+1' },

  // E
  EC: { description: 'Ecuador', flag: 'https://flagcdn.com/24x18/ec.png', dialCode: '+593' },
  EG: { description: 'Egypt', flag: 'https://flagcdn.com/24x18/eg.png', dialCode: '+20' },
  SV: { description: 'El Salvador', flag: 'https://flagcdn.com/24x18/sv.png', dialCode: '+503' },
  GQ: { description: 'Equatorial Guinea', flag: 'https://flagcdn.com/24x18/gq.png', dialCode: '+240' },
  ER: { description: 'Eritrea', flag: 'https://flagcdn.com/24x18/er.png', dialCode: '+291' },
  EE: { description: 'Estonia', flag: 'https://flagcdn.com/24x18/ee.png', dialCode: '+372' },
  SZ: { description: 'Eswatini', flag: 'https://flagcdn.com/24x18/sz.png', dialCode: '+268' },
  ET: { description: 'Ethiopia', flag: 'https://flagcdn.com/24x18/et.png', dialCode: '+251' },

  // F
  FK: { description: 'Falkland Islands (Malvinas)', flag: 'https://flagcdn.com/24x18/fk.png', dialCode: '+500' },
  FO: { description: 'Faroe Islands (the)', flag: 'https://flagcdn.com/24x18/fo.png', dialCode: '+298' },
  FJ: { description: 'Fiji', flag: 'https://flagcdn.com/24x18/fj.png', dialCode: '+679' },
  FI: { description: 'Finland', flag: 'https://flagcdn.com/24x18/fi.png', dialCode: '+358' },
  FR: { description: 'France', flag: 'https://flagcdn.com/24x18/fr.png', dialCode: '+33' },
  GF: { description: 'French Guiana', flag: 'https://flagcdn.com/24x18/gf.png', dialCode: '+594' },
  PF: { description: 'French Polynesia', flag: 'https://flagcdn.com/24x18/pf.png', dialCode: '+689' },
  TF: { description: 'French Southern Territories (the)', flag: 'https://flagcdn.com/24x18/tf.png', dialCode: '+262' },

  // G
  GA: { description: 'Gabon', flag: 'https://flagcdn.com/24x18/ga.png', dialCode: '+241' },
  GM: { description: 'Gambia (the)', flag: 'https://flagcdn.com/24x18/gm.png', dialCode: '+220' },
  GE: { description: 'Georgia', flag: 'https://flagcdn.com/24x18/ge.png', dialCode: '+995' },
  DE: { description: 'Germany', flag: 'https://flagcdn.com/24x18/de.png', dialCode: '+49' },
  GH: { description: 'Ghana', flag: 'https://flagcdn.com/24x18/gh.png', dialCode: '+233' },
  GI: { description: 'Gibraltar', flag: 'https://flagcdn.com/24x18/gi.png', dialCode: '+350' },
  GR: { description: 'Greece', flag: 'https://flagcdn.com/24x18/gr.png', dialCode: '+30' },
  GL: { description: 'Greenland', flag: 'https://flagcdn.com/24x18/gl.png', dialCode: '+299' },
  GD: { description: 'Grenada', flag: 'https://flagcdn.com/24x18/gd.png', dialCode: '+1' },
  GP: { description: 'Guadeloupe', flag: 'https://flagcdn.com/24x18/gp.png', dialCode: '+590' },
  GU: { description: 'Guam', flag: 'https://flagcdn.com/24x18/gu.png', dialCode: '+1' },
  GT: { description: 'Guatemala', flag: 'https://flagcdn.com/24x18/gt.png', dialCode: '+502' },
  GG: { description: 'Guernsey', flag: 'https://flagcdn.com/24x18/gg.png', dialCode: '+44' },
  GN: { description: 'Guinea', flag: 'https://flagcdn.com/24x18/gn.png', dialCode: '+224' },
  GW: { description: 'Guinea-Bissau', flag: 'https://flagcdn.com/24x18/gw.png', dialCode: '+245' },
  GY: { description: 'Guyana', flag: 'https://flagcdn.com/24x18/gy.png', dialCode: '+592' },

  // H
  HT: { description: 'Haiti', flag: 'https://flagcdn.com/24x18/ht.png', dialCode: '+509' },
  HM: { description: 'Heard Island and McDonald Islands', flag: 'https://flagcdn.com/24x18/hm.png', dialCode: '+672' },
  VA: { description: 'Holy See (the) [Vatican City State]', flag: 'https://flagcdn.com/24x18/va.png', dialCode: '+39' },
  HN: { description: 'Honduras', flag: 'https://flagcdn.com/24x18/hn.png', dialCode: '+504' },
  HK: { description: 'Hong Kong', flag: 'https://flagcdn.com/24x18/hk.png', dialCode: '+852' },
  HU: { description: 'Hungary', flag: 'https://flagcdn.com/24x18/hu.png', dialCode: '+36' },

  // I
  IS: { description: 'Iceland', flag: 'https://flagcdn.com/24x18/is.png', dialCode: '+354' },
  IN: { description: 'India', flag: 'https://flagcdn.com/24x18/in.png', dialCode: '+91' },
  ID: { description: 'Indonesia', flag: 'https://flagcdn.com/24x18/id.png', dialCode: '+62' },
  IR: { description: 'Iran (Islamic Republic of)', flag: 'https://flagcdn.com/24x18/ir.png', dialCode: '+98' },
  IQ: { description: 'Iraq', flag: 'https://flagcdn.com/24x18/iq.png', dialCode: '+964' },
  IE: { description: 'Ireland', flag: 'https://flagcdn.com/24x18/ie.png', dialCode: '+353' },
  IM: { description: 'Isle of Man', flag: 'https://flagcdn.com/24x18/im.png', dialCode: '+44' },
  IL: { description: 'Israel', flag: 'https://flagcdn.com/24x18/il.png', dialCode: '+972' },
  IT: { description: 'Italy', flag: 'https://flagcdn.com/24x18/it.png', dialCode: '+39' },

  // J
  JM: { description: 'Jamaica', flag: 'https://flagcdn.com/24x18/jm.png', dialCode: '+1' },
  JP: { description: 'Japan', flag: 'https://flagcdn.com/24x18/jp.png', dialCode: '+81' },
  JE: { description: 'Jersey', flag: 'https://flagcdn.com/24x18/je.png', dialCode: '+44' },
  JO: { description: 'Jordan', flag: 'https://flagcdn.com/24x18/jo.png', dialCode: '+962' },

  // K
  KZ: { description: 'Kazakhstan', flag: 'https://flagcdn.com/24x18/kz.png', dialCode: '+7' },
  KE: { description: 'Kenya', flag: 'https://flagcdn.com/24x18/ke.png', dialCode: '+254' },
  KI: { description: 'Kiribati', flag: 'https://flagcdn.com/24x18/ki.png', dialCode: '+686' },
  KP: { description: "Korea (the Democratic People's Republic of)", flag: 'https://flagcdn.com/24x18/kp.png', dialCode: '+850' },
  KR: { description: 'Korea (the Republic of)', flag: 'https://flagcdn.com/24x18/kr.png', dialCode: '+82' },
  KW: { description: 'Kuwait', flag: 'https://flagcdn.com/24x18/kw.png', dialCode: '+965' },
  KG: { description: 'Kyrgyzstan', flag: 'https://flagcdn.com/24x18/kg.png', dialCode: '+996' },

  // L
  LA: { description: "Lao People's Democratic Republic (the)", flag: 'https://flagcdn.com/24x18/la.png', dialCode: '+856' },
  LV: { description: 'Latvia', flag: 'https://flagcdn.com/24x18/lv.png', dialCode: '+371' },
  LB: { description: 'Lebanon', flag: 'https://flagcdn.com/24x18/lb.png', dialCode: '+961' },
  LS: { description: 'Lesotho', flag: 'https://flagcdn.com/24x18/ls.png', dialCode: '+266' },
  LR: { description: 'Liberia', flag: 'https://flagcdn.com/24x18/lr.png', dialCode: '+231' },
  LY: { description: 'Libya', flag: 'https://flagcdn.com/24x18/ly.png', dialCode: '+218' },
  LI: { description: 'Liechtenstein', flag: 'https://flagcdn.com/24x18/li.png', dialCode: '+423' },
  LT: { description: 'Lithuania', flag: 'https://flagcdn.com/24x18/lt.png', dialCode: '+370' },
  LU: { description: 'Luxembourg', flag: 'https://flagcdn.com/24x18/lu.png', dialCode: '+352' },

  // M
  MO: { description: 'Macao', flag: 'https://flagcdn.com/24x18/mo.png', dialCode: '+853' },
  MG: { description: 'Madagascar', flag: 'https://flagcdn.com/24x18/mg.png', dialCode: '+261' },
  MW: { description: 'Malawi', flag: 'https://flagcdn.com/24x18/mw.png', dialCode: '+265' },
  MY: { description: 'Malaysia', flag: 'https://flagcdn.com/24x18/my.png', dialCode: '+60' },
  MV: { description: 'Maldives', flag: 'https://flagcdn.com/24x18/mv.png', dialCode: '+960' },
  ML: { description: 'Mali', flag: 'https://flagcdn.com/24x18/ml.png', dialCode: '+223' },
  MT: { description: 'Malta', flag: 'https://flagcdn.com/24x18/mt.png', dialCode: '+356' },
  MH: { description: 'Marshall Islands (the)', flag: 'https://flagcdn.com/24x18/mh.png', dialCode: '+692' },
  MQ: { description: 'Martinique', flag: 'https://flagcdn.com/24x18/mq.png', dialCode: '+596' },
  MR: { description: 'Mauritania', flag: 'https://flagcdn.com/24x18/mr.png', dialCode: '+222' },
  MU: { description: 'Mauritius', flag: 'https://flagcdn.com/24x18/mu.png', dialCode: '+230' },
  YT: { description: 'Mayotte', flag: 'https://flagcdn.com/24x18/yt.png', dialCode: '+262' },
  MX: { description: 'Mexico', flag: 'https://flagcdn.com/24x18/mx.png', dialCode: '+52' },
  FM: { description: 'Micronesia (Federated States of)', flag: 'https://flagcdn.com/24x18/fm.png', dialCode: '+691' },
  MD: { description: 'Moldova (the Republic of)', flag: 'https://flagcdn.com/24x18/md.png', dialCode: '+373' },
  MC: { description: 'Monaco', flag: 'https://flagcdn.com/24x18/mc.png', dialCode: '+377' },
  MN: { description: 'Mongolia', flag: 'https://flagcdn.com/24x18/mn.png', dialCode: '+976' },
  ME: { description: 'Montenegro', flag: 'https://flagcdn.com/24x18/me.png', dialCode: '+382' },
  MS: { description: 'Montserrat', flag: 'https://flagcdn.com/24x18/ms.png', dialCode: '+1' },
  MA: { description: 'Morocco', flag: 'https://flagcdn.com/24x18/ma.png', dialCode: '+212' },
  MZ: { description: 'Mozambique', flag: 'https://flagcdn.com/24x18/mz.png', dialCode: '+258' },
  MM: { description: 'Myanmar', flag: 'https://flagcdn.com/24x18/mm.png', dialCode: '+95' },

  // N
  NA: { description: 'Namibia', flag: 'https://flagcdn.com/24x18/na.png', dialCode: '+264' },
  NR: { description: 'Nauru', flag: 'https://flagcdn.com/24x18/nr.png', dialCode: '+674' },
  NP: { description: 'Nepal', flag: 'https://flagcdn.com/24x18/np.png', dialCode: '+977' },
  NL: { description: 'Netherlands (the)', flag: 'https://flagcdn.com/24x18/nl.png', dialCode: '+31' },
  NC: { description: 'New Caledonia', flag: 'https://flagcdn.com/24x18/nc.png', dialCode: '+687' },
  NZ: { description: 'New Zealand', flag: 'https://flagcdn.com/24x18/nz.png', dialCode: '+64' },
  NI: { description: 'Nicaragua', flag: 'https://flagcdn.com/24x18/ni.png', dialCode: '+505' },
  NE: { description: 'Niger (the)', flag: 'https://flagcdn.com/24x18/ne.png', dialCode: '+227' },
  NG: { description: 'Nigeria', flag: 'https://flagcdn.com/24x18/ng.png', dialCode: '+234' },
  NU: { description: 'Niue', flag: 'https://flagcdn.com/24x18/nu.png', dialCode: '+683' },
  NF: { description: 'Norfolk Island', flag: 'https://flagcdn.com/24x18/nf.png', dialCode: '+672' },
  MK: { description: 'North Macedonia', flag: 'https://flagcdn.com/24x18/mk.png', dialCode: '+389' },
  MP: { description: 'Northern Mariana Islands (the)', flag: 'https://flagcdn.com/24x18/mp.png', dialCode: '+1' },
  NO: { description: 'Norway', flag: 'https://flagcdn.com/24x18/no.png', dialCode: '+47' },

  // O
  OM: { description: 'Oman', flag: 'https://flagcdn.com/24x18/om.png', dialCode: '+968' },

  // P
  PK: { description: 'Pakistan', flag: 'https://flagcdn.com/24x18/pk.png', dialCode: '+92' },
  PW: { description: 'Palau', flag: 'https://flagcdn.com/24x18/pw.png', dialCode: '+680' },
  PS: { description: 'Palestine, State of', flag: 'https://flagcdn.com/24x18/ps.png', dialCode: '+970' },
  PA: { description: 'Panama', flag: 'https://flagcdn.com/24x18/pa.png', dialCode: '+507' },
  PG: { description: 'Papua New Guinea', flag: 'https://flagcdn.com/24x18/pg.png', dialCode: '+675' },
  PY: { description: 'Paraguay', flag: 'https://flagcdn.com/24x18/py.png', dialCode: '+595' },
  PE: { description: 'Peru', flag: 'https://flagcdn.com/24x18/pe.png', dialCode: '+51' },
  PH: { description: 'Philippines (the)', flag: 'https://flagcdn.com/24x18/ph.png', dialCode: '+63' },
  PN: { description: 'Pitcairn', flag: 'https://flagcdn.com/24x18/pn.png', dialCode: '+64' },
  PL: { description: 'Poland', flag: 'https://flagcdn.com/24x18/pl.png', dialCode: '+48' },
  PT: { description: 'Portugal', flag: 'https://flagcdn.com/24x18/pt.png', dialCode: '+351' },
  PR: { description: 'Puerto Rico', flag: 'https://flagcdn.com/24x18/pr.png', dialCode: '+1' },

  // Q
  QA: { description: 'Qatar', flag: 'https://flagcdn.com/24x18/qa.png', dialCode: '+974' },

  // R
  RE: { description: 'Réunion', flag: 'https://flagcdn.com/24x18/re.png', dialCode: '+262' },
  RO: { description: 'Romania', flag: 'https://flagcdn.com/24x18/ro.png', dialCode: '+40' },
  RU: { description: 'Russian Federation (the)', flag: 'https://flagcdn.com/24x18/ru.png', dialCode: '+7' },
  RW: { description: 'Rwanda', flag: 'https://flagcdn.com/24x18/rw.png', dialCode: '+250' },

  // S
  BL: { description: 'Saint Barthélemy', flag: 'https://flagcdn.com/24x18/bl.png', dialCode: '+590' },
  SH: { description: 'Saint Helena, Ascension and Tristan da Cunha', flag: 'https://flagcdn.com/24x18/sh.png', dialCode: '+290' },
  KN: { description: 'Saint Kitts and Nevis', flag: 'https://flagcdn.com/24x18/kn.png', dialCode: '+1' },
  LC: { description: 'Saint Lucia', flag: 'https://flagcdn.com/24x18/lc.png', dialCode: '+1' },
  MF: { description: 'Saint Martin (French part)', flag: 'https://flagcdn.com/24x18/mf.png', dialCode: '+590' },
  PM: { description: 'Saint Pierre and Miquelon', flag: 'https://flagcdn.com/24x18/pm.png', dialCode: '+508' },
  VC: { description: 'Saint Vincent and the Grenadines', flag: 'https://flagcdn.com/24x18/vc.png', dialCode: '+1' },
  WS: { description: 'Samoa', flag: 'https://flagcdn.com/24x18/ws.png', dialCode: '+685' },
  SM: { description: 'San Marino', flag: 'https://flagcdn.com/24x18/sm.png', dialCode: '+378' },
  ST: { description: 'Sao Tome and Principe', flag: 'https://flagcdn.com/24x18/st.png', dialCode: '+239' },
  SA: { description: 'Saudi Arabia', flag: 'https://flagcdn.com/24x18/sa.png', dialCode: '+966' },
  SN: { description: 'Senegal', flag: 'https://flagcdn.com/24x18/sn.png', dialCode: '+221' },
  RS: { description: 'Serbia', flag: 'https://flagcdn.com/24x18/rs.png', dialCode: '+381' },
  SC: { description: 'Seychelles', flag: 'https://flagcdn.com/24x18/sc.png', dialCode: '+248' },
  SL: { description: 'Sierra Leone', flag: 'https://flagcdn.com/24x18/sl.png', dialCode: '+232' },
  SG: { description: 'Singapore', flag: 'https://flagcdn.com/24x18/sg.png', dialCode: '+65' },
  SX: { description: 'Sint Maarten (Dutch part)', flag: 'https://flagcdn.com/24x18/sx.png', dialCode: '+1' },
  SK: { description: 'Slovakia', flag: 'https://flagcdn.com/24x18/sk.png', dialCode: '+421' },
  SI: { description: 'Slovenia', flag: 'https://flagcdn.com/24x18/si.png', dialCode: '+386' },
  SB: { description: 'Solomon Islands', flag: 'https://flagcdn.com/24x18/sb.png', dialCode: '+677' },
  SO: { description: 'Somalia', flag: 'https://flagcdn.com/24x18/so.png', dialCode: '+252' },
  ZA: { description: 'South Africa', flag: 'https://flagcdn.com/24x18/za.png', dialCode: '+27' },
  GS: { description: 'South Georgia and the South Sandwich Islands', flag: 'https://flagcdn.com/24x18/gs.png' },
  SS: { description: 'South Sudan', flag: 'https://flagcdn.com/24x18/ss.png', dialCode: '+211' },
  ES: { description: 'Spain', flag: 'https://flagcdn.com/24x18/es.png', dialCode: '+34' },
  LK: { description: 'Sri Lanka', flag: 'https://flagcdn.com/24x18/lk.png', dialCode: '+94' },
  SD: { description: 'Sudan (the)', flag: 'https://flagcdn.com/24x18/sd.png', dialCode: '+249' },
  SR: { description: 'Suriname', flag: 'https://flagcdn.com/24x18/sr.png', dialCode: '+597' },
  SJ: { description: 'Svalbard and Jan Mayen', flag: 'https://flagcdn.com/24x18/sj.png', dialCode: '+47' },
  SE: { description: 'Sweden', flag: 'https://flagcdn.com/24x18/se.png', dialCode: '+46' },
  CH: { description: 'Switzerland', flag: 'https://flagcdn.com/24x18/ch.png', dialCode: '+41' },
  SY: { description: 'Syrian Arab Republic', flag: 'https://flagcdn.com/24x18/sy.png', dialCode: '+963' },

  // T
  TW: { description: 'Taiwan (Province of China)', flag: 'https://flagcdn.com/24x18/tw.png', dialCode: '+886' },
  TJ: { description: 'Tajikistan', flag: 'https://flagcdn.com/24x18/tj.png', dialCode: '+992' },
  TZ: { description: 'Tanzania, United Republic of', flag: 'https://flagcdn.com/24x18/tz.png', dialCode: '+255' },
  TH: { description: 'Thailand', flag: 'https://flagcdn.com/24x18/th.png', dialCode: '+66' },
  TL: { description: 'Timor-Leste', flag: 'https://flagcdn.com/24x18/tl.png', dialCode: '+670' },
  TG: { description: 'Togo', flag: 'https://flagcdn.com/24x18/tg.png', dialCode: '+228' },
  TK: { description: 'Tokelau', flag: 'https://flagcdn.com/24x18/tk.png', dialCode: '+690' },
  TO: { description: 'Tonga', flag: 'https://flagcdn.com/24x18/to.png', dialCode: '+676' },
  TT: { description: 'Trinidad and Tobago', flag: 'https://flagcdn.com/24x18/tt.png', dialCode: '+1' },
  TN: { description: 'Tunisia', flag: 'https://flagcdn.com/24x18/tn.png', dialCode: '+216' },
  TR: { description: 'Türkiye', flag: 'https://flagcdn.com/24x18/tr.png', dialCode: '+90' },
  TM: { description: 'Turkmenistan', flag: 'https://flagcdn.com/24x18/tm.png', dialCode: '+993' },
  TC: { description: 'Turks and Caicos Islands (the)', flag: 'https://flagcdn.com/24x18/tc.png', dialCode: '+1' },
  TV: { description: 'Tuvalu', flag: 'https://flagcdn.com/24x18/tv.png', dialCode: '+688' },

  // U
  UG: { description: 'Uganda', flag: 'https://flagcdn.com/24x18/ug.png', dialCode: '+256' },
  UA: { description: 'Ukraine', flag: 'https://flagcdn.com/24x18/ua.png', dialCode: '+380' },
  AE: { description: 'United Arab Emirates (the)', flag: 'https://flagcdn.com/24x18/ae.png', dialCode: '+971' },
  GB: { description: 'United Kingdom of Great Britain and Northern Ireland (the)', flag: 'https://flagcdn.com/24x18/gb.png', dialCode: '+44' },
  UM: { description: 'United States Minor Outlying Islands (the)', flag: 'https://flagcdn.com/24x18/um.png', dialCode: '+1' },
  US: { description: 'United States of America (the)', flag: 'https://flagcdn.com/24x18/us.png', dialCode: '+1' },
  UY: { description: 'Uruguay', flag: 'https://flagcdn.com/24x18/uy.png', dialCode: '+598' },
  UZ: { description: 'Uzbekistan', flag: 'https://flagcdn.com/24x18/uz.png', dialCode: '+998' },

  // V
  VU: { description: 'Vanuatu', flag: 'https://flagcdn.com/24x18/vu.png', dialCode: '+678' },
  VE: { description: 'Venezuela (Bolivarian Republic of)', flag: 'https://flagcdn.com/24x18/ve.png', dialCode: '+58' },
  VN: { description: 'Viet Nam', flag: 'https://flagcdn.com/24x18/vn.png', dialCode: '+84' },
  VG: { description: 'Virgin Islands (British)', flag: 'https://flagcdn.com/24x18/vg.png', dialCode: '+1' },
  VI: { description: 'Virgin Islands (U.S.)', flag: 'https://flagcdn.com/24x18/vi.png', dialCode: '+1' },

  // W
  WF: { description: 'Wallis and Futuna', flag: 'https://flagcdn.com/24x18/wf.png', dialCode: '+681' },
  EH: { description: 'Western Sahara', flag: 'https://flagcdn.com/24x18/eh.png', dialCode: '+212' },

  // Y
  YE: { description: 'Yemen', flag: 'https://flagcdn.com/24x18/ye.png', dialCode: '+967' },

  // Z
  ZM: { description: 'Zambia', flag: 'https://flagcdn.com/24x18/zm.png', dialCode: '+260' },
  ZW: { description: 'Zimbabwe', flag: 'https://flagcdn.com/24x18/zw.png', dialCode: '+263' },
  

};

// Definición del tipo para el objeto de idiomas
export type LanguageData = {
  [key: string]: {
    description: string; // Nombre del idioma en inglés
    nativeName: string; // Nombre del idioma en su propio idioma
  };
};

// Objeto completo con los códigos de idioma ISO 639-1 más comunes
export const ISO_LANGUAGES: LanguageData = {
  // A
  ab: { description: 'Abkhazian', nativeName: 'аҧсуа' },
  aa: { description: 'Afar', nativeName: 'Afaraf' },
  af: { description: 'Afrikaans', nativeName: 'Afrikaans' },
  ak: { description: 'Akan', nativeName: 'Akan' },
  sq: { description: 'Albanian', nativeName: 'Shqip' },
  am: { description: 'Amharic', nativeName: 'አማርኛ' },
  ar: { description: 'Arabic', nativeName: 'العربية' },
  an: { description: 'Aragonese', nativeName: 'Aragonés' },
  hy: { description: 'Armenian', nativeName: 'Հայերեն' },
  as: { description: 'Assamese', nativeName: 'অসমীয়া' },
  av: { description: 'Avaric', nativeName: 'авар мацӀ, магӀарул мацӀ' },
  ae: { description: 'Avestan', nativeName: 'avesta' },
  ay: { description: 'Aymara', nativeName: 'aymar aru' },
  az: { description: 'Azerbaijani', nativeName: 'azərbaycan dili, تۆرکجه' },

  // B
  bm: { description: 'Bambara', nativeName: 'bamanankan' },
  ba: { description: 'Bashkir', nativeName: 'башҡорт теле' },
  eu: { description: 'Basque', nativeName: 'euskara, euskera' },
  be: { description: 'Belarusian', nativeName: 'Беларуская' },
  bn: { description: 'Bengali', nativeName: 'বাংলা' },
  bh: { description: 'Bihari languages', nativeName: 'भोजपुरी' },
  bi: { description: 'Bislama', nativeName: 'Bislama' },
  bs: { description: 'Bosnian', nativeName: 'bosanski jezik' },
  br: { description: 'Breton', nativeName: 'brezhoneg' },
  bg: { description: 'Bulgarian', nativeName: 'български език' },
  my: { description: 'Burmese', nativeName: 'ဗမာစာ' },

  // C
  ca: { description: 'Catalan, Valencian', nativeName: 'Català' },
  ch: { description: 'Chamorro', nativeName: 'Chamoru' },
  ce: { description: 'Chechen', nativeName: 'нохчийн мотт' },
  ny: { description: 'Chichewa, Chewa, Nyanja', nativeName: 'chiCheŵa, chinyanja' },
  zh: { description: 'Chinese', nativeName: '中文 (Zhōngwén), 汉语, 漢語' },
  cv: { description: 'Chuvash', nativeName: 'чӑваш чӗлхи' },
  kw: { description: 'Cornish', nativeName: 'Kernewek' },
  co: { description: 'Corsican', nativeName: 'corsu, lingua corsa' },
  cr: { description: 'Cree', nativeName: ' Cree' },
  hr: { description: 'Croatian', nativeName: 'Hrvatski' },
  cs: { description: 'Czech', nativeName: 'čeština, český jazyk' },

  // D
  da: { description: 'Danish', nativeName: 'dansk' },
  dv: { description: 'Divehi, Dhivehi, Maldivian', nativeName: 'ދިވެހި' },
  nl: { description: 'Dutch, Flemish', nativeName: 'Nederlands, Vlaams' },
  dz: { description: 'Dzongkha', nativeName: 'རྫོང་ཁ' },

  // E
  en: { description: 'English', nativeName: 'English' },
  eo: { description: 'Esperanto', nativeName: 'Esperanto' },
  et: { description: 'Estonian', nativeName: 'eesti, eesti keel' },
  ee: { description: 'Ewe', nativeName: 'Eʋegbe' },

  // F
  fo: { description: 'Faroese', nativeName: 'føroyskt' },
  fj: { description: 'Fijian', nativeName: 'vosa Vakaviti' },
  fi: { description: 'Finnish', nativeName: 'suomi, suomen kieli' },
  fr: { description: 'French', nativeName: 'français, langue française' },
  fy: { description: 'Western Frisian', nativeName: 'Frysk' },
  ff: { description: 'Fulah', nativeName: 'Fulfulde, Pulaar, Pular' },

  // G
  gl: { description: 'Galician', nativeName: 'Galego' },
  ka: { description: 'Georgian', nativeName: 'ქართული' },
  de: { description: 'German', nativeName: 'Deutsch' },
  el: { description: 'Greek (Modern)', nativeName: 'Ελληνικά' },
  gn: { description: 'Guarani', nativeName: 'Avañeẽ' },
  gu: { description: 'Gujarati', nativeName: 'ગુજરાતી' },

  // H
  ht: { description: 'Haitian, Haitian Creole', nativeName: 'Kreyòl ayisyen' },
  ha: { description: 'Hausa', nativeName: 'Hausa, هَوُسَ' },
  he: { description: 'Hebrew', nativeName: 'עברית' },
  hz: { description: 'Herero', nativeName: 'Otjiherero' },
  hi: { description: 'Hindi', nativeName: 'हिन्दी, हिंदी' },
  ho: { description: 'Hiri Motu', nativeName: 'Hiri Motu' },
  hu: { description: 'Hungarian', nativeName: 'Magyar' },

  // I
  is: { description: 'Icelandic', nativeName: 'Íslenska' },
  io: { description: 'Ido', nativeName: 'Ido' },
  ig: { description: 'Igbo', nativeName: 'Asụsụ Igbo' },
  id: { description: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  ia: { description: 'Interlingua (International Auxiliary Language Association)', nativeName: 'Interlingua' },
  ie: { description: 'Interlingue, Occidental', nativeName: 'Interlingue' },
  iu: { description: 'Inuktitut', nativeName: 'ᐃᓄᒃᑎᑐᑦ' },
  ik: { description: 'Inupiaq', nativeName: 'Iñupiaq, Iñupiak' },
  ga: { description: 'Irish', nativeName: 'Gaeilge' },
  it: { description: 'Italian', nativeName: 'Italiano' },

  // J
  ja: { description: 'Japanese', nativeName: '日本語 (にほんご)' },
  jv: { description: 'Javanese', nativeName: 'basa Jawa' },

  // K
  kl: { description: 'Kalaallisut, Greenlandic', nativeName: 'kalaallisut, kalaallit oqaasii' },
  kn: { description: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  kr: { description: 'Kanuri', nativeName: 'Kanuri' },
  ks: { description: 'Kashmiri', nativeName: 'कश्मीरी, كشميري‎' },
  kk: { description: 'Kazakh', nativeName: 'Қазақ тілі' },
  km: { description: 'Central Khmer', nativeName: 'ខ្មែរ, ភាសាខ្មែរ' },
  ki: { description: 'Kikuyu, Gikuyu', nativeName: 'Gĩkũyũ' },
  rw: { description: 'Kinyarwanda', nativeName: 'Ikinyarwanda' },
  ky: { description: 'Kirghiz, Kyrgyz', nativeName: 'Кыргызча, Кыргыз тили' },
  kv: { description: 'Komi', nativeName: 'коми кыв' },
  kg: { description: 'Kongo', nativeName: 'Kikongo' },
  ko: { description: 'Korean', nativeName: '한국어 (韓國語), 조선말 (朝鮮語)' },
  ku: { description: 'Kurdish', nativeName: 'Kurdî, كوردی‎' },

  // L
  lo: { description: 'Lao', nativeName: 'ພາສາລາວ' },
  la: { description: 'Latin', nativeName: 'latine, lingua latina' },
  lv: { description: 'Latvian', nativeName: 'latviešu valoda' },
  li: { description: 'Limburgan, Limburger, Limburgish', nativeName: 'Limburgs' },
  ln: { description: 'Lingala', nativeName: 'Lingála' },
  lt: { description: 'Lithuanian', nativeName: 'lietuvių kalba' },
  lu: { description: 'Luba-Katanga', nativeName: 'ciluba' },
  lb: { description: 'Luxembourgish, Letzeburgesch', nativeName: 'Lëtzebuergesch' },

  // M
  mk: { description: 'Macedonian', nativeName: 'македонски јазик' },
  mg: { description: 'Malagasy', nativeName: 'Malagasy fiteny' },
  ms: { description: 'Malay', nativeName: 'bahasa Melayu, بهاس ملايو‎' },
  ml: { description: 'Malayalam', nativeName: 'മലയാളം' },
  mt: { description: 'Maltese', nativeName: 'Malti' },
  gv: { description: 'Manx', nativeName: 'Gaelg, Gailck' },
  mi: { description: 'Maori', nativeName: 'te reo Māori' },
  mr: { description: 'Marathi', nativeName: 'मराठी' },
  mh: { description: 'Marshallese', nativeName: 'Kajin M̧ajeļ' },
  mn: { description: 'Mongolian', nativeName: 'монгол' },
  na: { description: 'Nauru', nativeName: 'Ekakairũ Naoero' },
  nv: { description: 'Navajo, Navaho', nativeName: 'Diné bizaad, Dinékʼehǰí' },
  nd: { description: 'Ndebele, North', nativeName: 'isiNdebele' },
  ne: { description: 'Nepali', nativeName: 'नेपाली' },
  se: { description: 'Northern Sami', nativeName: 'Davvisámegiella' },
  no: { description: 'Norwegian', nativeName: 'Norsk' },
  nb: { description: 'Norwegian Bokmål', nativeName: 'Norsk bokmål' },
  nn: { description: 'Norwegian Nynorsk', nativeName: 'Norsk nynorsk' },

  // O
  oc: { description: 'Occitan (post 1500)', nativeName: 'Occitan' },
  or: { description: 'Oriya', nativeName: 'ଓଡ଼ିଆ' },
  om: { description: 'Oromo', nativeName: 'Afaan Oromoo' },
  os: { description: 'Ossetian, Ossetic', nativeName: 'ирон ӕвзаг' },

  // P
  pi: { description: 'Pali', nativeName: 'पालि, Pāli' },
  fa: { description: 'Persian', nativeName: 'فارسی' },
  pl: { description: 'Polish', nativeName: 'polski' },
  pt: { description: 'Portuguese', nativeName: 'Português' },
  pa: { description: 'Panjabi, Punjabi', nativeName: 'ਪੰਜਾਬੀ, پنجابی‎' },
  ps: { description: 'Pushto, Pashto', nativeName: 'پښتو' },

  // Q
  qu: { description: 'Quechua', nativeName: 'Runa Simi, Kichwa' },

  // R
  ro: { description: 'Romanian, Moldavian, Moldovan', nativeName: 'Română' },
  rm: { description: 'Romansh', nativeName: 'Rumantsch Grischun' },
  rn: { description: 'Rundi', nativeName: 'Kirundi' },
  ru: { description: 'Russian', nativeName: 'русский язык' },

  // S
  sm: { description: 'Samoan', nativeName: 'gagana faa Samoa' },
  sg: { description: 'Sango', nativeName: 'yângâ tî sängö' },
  sa: { description: 'Sanskrit', nativeName: 'संस्कृतम्' },
  sc: { description: 'Sardinian', nativeName: 'sardu' },
  gd: { description: 'Gaelic, Scottish Gaelic', nativeName: 'Gàidhlig' },
  sr: { description: 'Serbian', nativeName: 'српски језик' },
  sn: { description: 'Shona', nativeName: 'chiShona' },
  sd: { description: 'Sindhi', nativeName: 'सिन्धी, سنڌي، سندھی‎' },
  si: { description: 'Sinhala, Sinhalese', nativeName: 'සිංහල' },
  sk: { description: 'Slovak', nativeName: 'slovenčina, slovenský jazyk' },
  sl: { description: 'Slovenian', nativeName: 'slovenski jezik, slovenščina' },
  so: { description: 'Somali', nativeName: 'Soomaaliga, af Soomaali' },
  st: { description: 'Southern Sotho', nativeName: 'Sesotho' },
  es: { description: 'Spanish, Castilian', nativeName: 'Español' },
  su: { description: 'Sundanese', nativeName: 'Basa Sunda' },
  sw: { description: 'Swahili', nativeName: 'Kiswahili' },
  ss: { description: 'Swati', nativeName: 'SiSwati' },
  sv: { description: 'Swedish', nativeName: 'svenska' },

  // T
  tl: { description: 'Tagalog', nativeName: 'Tagalog' },
  ty: { description: 'Tahitian', nativeName: 'Reo Tahiti' },
  tg: { description: 'Tajik', nativeName: 'тоҷикӣ, toçikī, تاجیکی‎' },
  ta: { description: 'Tamil', nativeName: 'தமிழ்' },
  tt: { description: 'Tatar', nativeName: 'татар теле, tatar tele' },
  te: { description: 'Telugu', nativeName: 'తెలుగు' },
  th: { description: 'Thai', nativeName: 'ไทย' },
  bo: { description: 'Tibetan', nativeName: 'བོད་ཡིག' },
  ti: { description: 'Tigrinya', nativeName: 'ትግርኛ' },
  to: { description: 'Tonga (Tonga Islands)', nativeName: 'faka Tonga' },
  ts: { description: 'Tsonga', nativeName: 'Tsonga' },
  tn: { description: 'Tswana', nativeName: 'Setswana' },
  tr: { description: 'Turkish', nativeName: 'Türkçe' },
  tk: { description: 'Turkmen', nativeName: 'Türkmen, Түркмен' },
  tw: { description: 'Twi', nativeName: 'Twi' },

  // U
  ug: { description: 'Uighur, Uyghur', nativeName: 'Uyƣurqə, ئۇيغۇرچە‎' },
  uk: { description: 'Ukrainian', nativeName: 'Українська' },
  ur: { description: 'Urdu', nativeName: 'اردو' },
  uz: { description: 'Uzbek', nativeName: 'Ўзбек, ‫اوزبېک‎' },

  // V
  ve: { description: 'Venda', nativeName: 'Tshivenḓa' },
  vi: { description: 'Vietnamese', nativeName: 'Tiếng Việt' },

  // W
  vo: { description: 'Volapük', nativeName: 'Volapük' },
  wa: { description: 'Walloon', nativeName: 'Walon' },
  cy: { description: 'Welsh', nativeName: 'Cymraeg' },

  // X
  xh: { description: 'Xhosa', nativeName: 'isiXhosa' },

  // Y
  yi: { description: 'Yiddish', nativeName: 'ייִדיש' },
  yo: { description: 'Yoruba', nativeName: 'Yorùbá' },

  // Z
  za: { description: 'Zhuang, Chuang', nativeName: 'Saɯ cueŋƅ, Saw cuengh' },
  zu: { description: 'Zulu', nativeName: 'isiZulu' },
};
export const ISO_LANGUAGES_SELECT = [{value: "es", label: "Español"}, ...Object.entries(ISO_LANGUAGES).filter(([code]) => code !== "es").map(([code, data]) => ({
  value: code,
  label: data.description
}))];
export const ISO_COUNTRIES_SELECT = [{value: "ES", label: "España", flag: ISO_COUNTRIES["ES"].flag}, ...Object.entries(ISO_COUNTRIES).filter(([code]) => code !== "ES").map(([code, data]) => ({
  value: code,
  label: data.description,
  flag: data.flag
}))]; ;
